import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { LeftOutlined, MenuOutlined, PlusCircleFilled } from '@ant-design/icons';
import { Col, Drawer, Image, Row, Typography, Form } from 'antd';

import Navigation from '../../../../components/OfficialStoreNavigation';
import { OfficialStore } from '@models/OfficialStore';
import * as S from '../../styles';

const { Text, Title } = Typography;

interface OfficialStoreQuestionsHeaderProps {
  officialStore: OfficialStore;
  showModalNewQuestion: Function;
}

const OfficialStoreQuestionsHeader: React.FC<OfficialStoreQuestionsHeaderProps> = ({
  officialStore,
  showModalNewQuestion,
}) => {
  const history = useHistory();

  const [drawerIsVisible, setDrawerIsVisible] = useState(false);

  const backUrl = () => {
    history.go(-1);
  };

  const onCloseDrawer = () => {
    setDrawerIsVisible(false);
  };

  const showDrawer = () => {
    setDrawerIsVisible(true);
  };

  return (
    <>
      <Row className="mt-3" justify="space-between">
        <Col className="d-flex" style={{ alignItems: 'center' }}>
          <LeftOutlined onClick={() => backUrl()} style={{ fontSize: '20px', marginRight: '12px' }} />

          <Image
            src={officialStore.logoUrl}
            alt="Logo da empresa"
            preview={false}
            style={{ width: '100%', maxWidth: '120px', borderRadius: '8px' }}
          />

          <Row style={{ flexDirection: 'column', marginLeft: '12px' }}>
            <Col>
              <Title level={5} style={{ margin: '0' }}>
                {officialStore.description}
              </Title>
            </Col>
            <Col>
              <Text>#{officialStore.officialStoreId}</Text>
            </Col>
          </Row>
        </Col>

        <Col className="d-flex" style={{ alignItems: 'center' }}>
          <Form.Item style={{ margin: '0 16px 0 0' }}>
            <S.ButtonContainer onClick={() => showModalNewQuestion()}>
              <PlusCircleFilled twoToneColor="#510c76" style={{ fontSize: '20px' }} />
              <span style={{ marginLeft: '4px' }}>Nova Pergunta</span>
            </S.ButtonContainer>
          </Form.Item>

          <MenuOutlined onClick={showDrawer} style={{ fontSize: '22px', color: '#510c76', cursor: 'pointer' }} />
          <Drawer
            placement="right"
            onClose={onCloseDrawer}
            visible={drawerIsVisible}
            closable={false}
            bodyStyle={{ padding: '0' }}
          >
            <Navigation officialStore={officialStore} />
          </Drawer>
        </Col>
      </Row>
    </>
  );
};

export default OfficialStoreQuestionsHeader;
